// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"381":"8af392f1","768":"8751b930"}[chunkId] + ".chunk.js");